/**
 *
 * @param {object|number|string} variable
 * @return {boolean}
 */
export const empty = (variable) =>
  variable === false ||
  variable === "" ||
  variable === null ||
  variable === {} ||
  variable === [] ||
  variable === 0 ||
  variable === undefined ||
  (typeof variable === "object" && Object.keys(variable).length <= 0);

export const put = (url, data) => {
  return fetch(url, {
    method: "PUT",
    mode: "same-origin",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data),
  });
};

export const post = (url, data) => {
  return fetch(url, {
    method: "POST",
    mode: "same-origin",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data),
  });
};

export const deleteRequest = (url, data) => {
  return fetch(url, {
    method: "DELETE",
    mode: "same-origin",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data),
  });
};

export const getUrlParam = (name) => {
  const url = window.location.href;
  const regex = new RegExp(`${name}\=([0-9 a-z A-Z \_]*)(\&|$)`);
  const matches = url.match(regex);

  if (empty(matches)) {
    return false;
  }

  return matches[1];
};

export const resetScroll = (element) => {
  setTimeout(() => {
    const y = element.getBoundingClientRect().top + window.scrollY;
    window.scroll({
      top: y - 50,
      behavior: "smooth",
    });
  }, 50);
};

export const getELearningId = () => {
  const url = window.location.href;
  const matches = url.match(/(?<id>\d+)(\?|$)/);
  const errorText = "there is no e-learning id in url";

  if (empty(matches)) {
    throw errorText;
  }

  if (empty(matches.groups.id)) {
    throw errorText;
  }

  return parseInt(matches.groups.id);
};

export const getContainerBorderGapPixels = () => {
  const $container = $("#e-learning-display");
  const containerWidth = parseInt($container.width());
  const windowWidth = parseInt(window.outerWidth);

  if (windowWidth < 800) {
    return 0;
  }

  return (windowWidth - containerWidth) / 2 + 10;
};

export const rgbaToHex = (color) => {
  const rgba = color.replace(/^rgba?\(|\s+|\)$/g, "").split(",");
  return `#${(
    (1 << 24) +
    (parseInt(rgba[0]) << 16) +
    (parseInt(rgba[1]) << 8) +
    parseInt(rgba[2])
  )
    .toString(16)
    .slice(1)}`;
};
